import { CycleUtils } from '@wix/package-picker-shared';
const safeDurationInMonths = cycle => {
  try {
    return CycleUtils.convertCycleDurationToMonths(cycle);
  } catch {
    return null;
  }
};
export const findAdjacentCycle = (items, currentCycle, direction) => {
  var _candidates$filter$so2;
  const currentMonths = safeDurationInMonths(currentCycle);
  if (currentMonths === null) {
    return undefined;
  }
  const candidates = items.map(item => ({
    item,
    months: safeDurationInMonths(item.cycle)
  })).filter(candidate => candidate.months !== null);
  if (direction === 'higher') {
    var _candidates$filter$so;
    return (_candidates$filter$so = candidates.filter(candidate => candidate.months > currentMonths).sort((a, b) => a.months - b.months)[0]) == null ? void 0 : _candidates$filter$so.item;
  }
  return (_candidates$filter$so2 = candidates.filter(candidate => candidate.months < currentMonths).sort((a, b) => b.months - a.months)[0]) == null ? void 0 : _candidates$filter$so2.item;
};
//# sourceMappingURL=findAdjacentCycle.js.map